import * as Sentry from '@sentry/browser';
import { ActionKeys } from '~/actions/constants';
import * as invoiceItemsActions from '~/actions/invoice-items.actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as invoiceItemsService from '~/services/invoice-items.service';
import * as invoicesService from '~/services/invoices.service';
import { fromJSON } from '~/types/InvoiceItem';

export function* exportInvoiceItems(
  action: ReturnType<typeof invoiceItemsActions.exportTransactionsInvoiceItems>,
) {
  try {
    const { startDate, endDate, invoiceStatus, invoiceItemType, storeName, carrierAccount } =
      action.payload.filter;
    const {
      data: {
        links: { csv_export },
      },
    } = yield call(invoiceItemsService.exportInvoiceItems, {
      startDate: startDate?.toISOString(),
      endDate: endDate?.toISOString(),
      isPaid: invoiceStatus ? invoiceStatus.value === 'PAID' : undefined,
      invoiceItemType: invoiceItemType?.value.toString(),
      shopApp: storeName?.value.toString(),
      carrierAccountId: carrierAccount?.value.toString(),
    });
    yield put(invoiceItemsActions.exportTransactionsInvoiceItemsSuccess(csv_export));
  } catch (e) {
    // TODO: This is likely a bug, e is probably an Error, isn't it?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    yield put(invoiceItemsActions.exportTransactionsInvoiceItemsError(e as any));
  }
}

export function* searchInvoiceItems(
  action: ReturnType<typeof invoiceItemsActions.fetchTransactionsInvoiceItems>,
) {
  try {
    const {
      data: { results, count },
    }: invoiceItemsService.JSONSearchInvoiceItemsResponse = yield call(
      invoiceItemsService.searchInvoiceItems,
      action.payload.pageNumber,
      action.payload.pageSize,
      action.payload.searchQuery,
      action.payload.startDate,
      action.payload.endDate,
      action.payload.paymentStatus,
      action.payload.invoiceItemType,
      action.payload.shopApp,
      action.payload.carrierAccountId,
    );

    yield put(
      invoiceItemsActions.fetchTransactionsInvoiceItemsSuccess(
        results.map(fromJSON),
        action.payload.pageNumber || 1,
        Math.ceil(count / (action.payload.pageSize || 25)),
      ),
    );
  } catch (e) {
    yield put(invoiceItemsActions.fetchTransactionsInvoiceItemsError(e as Error));
    Sentry.captureException(e);
  }
}

export function* fetchInvoiceItemsOfInvoice(
  action: ReturnType<typeof invoiceItemsActions.fetchInvoiceItemsOfInvoice>,
) {
  try {
    const {
      data: { results },
    }: invoiceItemsService.JSONSearchInvoiceItemsResponse = yield call(
      invoicesService.getInvoiceItemsOfInvoice,
      action.payload.invoiceId,
    );

    yield put(invoiceItemsActions.fetchInvoiceItemsOfInvoiceSuccess(results.map(fromJSON)));
  } catch (e) {
    // TODO: This is likely a bug, e is probably an Error, isn't it?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    yield put(invoiceItemsActions.fetchInvoiceItemsOfInvoiceError(e as any));
  }
}

export default [
  takeLatest(ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT, exportInvoiceItems),
  takeLatest(ActionKeys.TRANSACTIONS_INVOICE_ITEMS_FETCH, searchInvoiceItems),
  takeLatest(ActionKeys.DISPLAY_INVOICE_INVOICE_ITEMS_FETCH, fetchInvoiceItemsOfInvoice),
];
